export default __webpack_public_path__ + "static/media/logo.3c18f846.svg";